import { Fragment } from "react"
import PropTypes from "prop-types"
import { StackView, Button } from "@planningcenter/tapestry-react"
import { Link } from "@reach/router"
import { css } from "@emotion/core"
import { colors } from "components/shared/admin_colors"

const styles = {
  sideNav: css`
    @media (min-width: 720px) {
      margin-right: 32px;
      width: 224px;
    }
    @media (min-width: 1600px) {
      width: 260px;
    }
  `
}

const SideNav = ({ navItems }) => {
  const getClassName = ({ isCurrent }) => {
    return {
      className: `nav-link d-f ai-c jc-sb ${isCurrent ? "active" : ""}`
    }
  }

  const renderNavItem = item => {
    if (item.type === "button") {
      const navButton = <Button title={item.text} variant="outline" onClick={item.onClick} />

      return (
        <>
          {item.linkTo && <Link to={item.linkTo}>{navButton}</Link>}
          {item.onClick && navButton}
        </>
      )
    } else if (item.type === "label") {
      return (
        <>
          <h5 className="mt-2">{item.text}</h5>
          {item.children || <span>{item.subText}</span>}
        </>
      )
    } else if (item.type === "header") {
      return (
        <StackView
          axis="horizontal"
          alignment="center"
          distribution="space-between"
          marginTop={3}
          marginBottom={1}
          paddingBottom={1}
          borderBottom={`1px solid ${colors.neutral_060}`}
        >
          <h3 className="h4 mb-0 mr-1 fw-500 truncate">{item.text}</h3>
          {item.children || <span>{item.subText}</span>}
        </StackView>
      )
    } else {
      const AnchorTag = item.type || Link

      const anchorProps = {
        ...(item.type === "a" && {
          ...(item.onClick ? { onClick: item.onClick } : { href: item.linkTo }),
          ...getClassName(item)
        }),
        ...(item.type !== "a" && { to: item.linkTo, getProps: getClassName })
      }

      return (
        <AnchorTag {...anchorProps}>
          <div className="truncate">{item.text}</div>
          {item.children || (
            <span className="c-neutral-700 font-size-5 pt-2p fw-400 pl-1 ta-r ws-nw">
              {item.subText}
            </span>
          )}
        </AnchorTag>
      )
    }
  }

  return (
    <aside css={styles.sideNav}>
      <nav>
        {Object.entries(navItems).map(([key, itemGroup]) => (
          <Fragment key={key}>
            {itemGroup.map(item => (
              <div role="none" key={item.key || item.text}>
                {renderNavItem(item)}
              </div>
            ))}
          </Fragment>
        ))}
      </nav>
    </aside>
  )
}

SideNav.propTypes = {
  navItems: PropTypes.shape({
    text: PropTypes.string,
    subText: PropTypes.string,
    type: PropTypes.string,
    linkTo: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.shape({})
  })
}

export default SideNav
